// @flow

export const FEATURE_NAMES = {
  AGGREGATE_RESULTS: "aggregateResults",
  CALENDAR: "calendar",
  ROUTE_BEST_RESULTS: "routeBestResults",
  RESULTS: "results",
  CHEAPER_OPTION_RADIUS: "cheaperOption-radius",
  CHEAPER_OPTION_DATE: "cheaperOption-date",
  MAP: "map",
  PARALLEL_RESULTS: "parallelResults",
  WOWAIR: "wowair",
  KAYAK: "kayak",

  POLL_UMBRELLA: "poll_umbrella",
}
